import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { TApi, TRoutes } from '../../../../shared/const'
import { formatVienna } from '../../../../shared/datetime'

import { certificateFileName, downloadCertificate } from './data'

import styles from './style.module.scss'

/**
 * Der Moment, in dem der Kurs geschafft ist: großer Glückwunsch, die Urkunde
 * zum Herunterladen und der Prüfcode, mit dem ein Betrieb sie nachprüfen kann.
 */
export default function Completion({ course, completion }) {
	const { t } = useTranslation()
	const history = useHistory()
	const [laedt, setLaedt] = useState(false)

	// Die Adresse baut die Oberfläche selbst: `certificateUrl` in der Antwort
	// steht ohne den Vorsatz `/api` (Pfad im Backend), den die Anfragen hier brauchen.
	const url = course ? TApi.COURSE_CERTIFICATE(course.id) : null

	const holen = () => {
		if (!url) return
		setLaedt(true)
		downloadCertificate(url, certificateFileName(course?.title)).finally(() => setLaedt(false))
	}

	return (
		<div className={styles.celebrate} role="status">
			<div className={styles.trophy} aria-hidden="true">
				🏆
			</div>
			<h1 className={styles.celebrateTitle}>{t('Congratulations — course completed!')}</h1>
			<p className={styles.celebrateText}>
				{t('You have finished all modules of „{{title}}“. Your certificate is ready.', {
					title: course?.title || ''
				})}
				<br />
				{completion.completedAt && (
					<>
						{t('Completed on {{date}}', { date: formatVienna(completion.completedAt, 'dd.MM.yyyy') })}
						{' · '}
					</>
				)}
				{t('Check code')}: <span className={styles.code}>{completion.code}</span>
			</p>
			<div className={styles.actions} style={{ justifyContent: 'center' }}>
				<button type="button" className={styles.play} onClick={holen} disabled={laedt}>
					{laedt ? t('Preparing…') : t('Download certificate')}
				</button>
				{course && (
					<button type="button" className={styles.ghost} onClick={() => history.push(TRoutes.COURSE(course.id))}>
						{t('Back to the course')}
					</button>
				)}
			</div>
		</div>
	)
}

Completion.propTypes = {
	course: PropTypes.object,
	completion: PropTypes.shape({
		code: PropTypes.string,
		completedAt: PropTypes.string,
		certificateUrl: PropTypes.string
	}).isRequired
}
